import { Component, OnInit, ViewChild, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import {
  PatientsResultComponent, BaseComponent, QueryService, SearchService, TitleService, FilterService, ReportKeys, ResultGroupType,
  TestResult_PatientsByResultRow
} from '../../core';
import { TranslateService } from '@ngx-translate/core';
import { NgxMatToastService } from 'ngx-mat-toast';
import { MatRadioChange } from '@angular/material/radio';
import { GoogleAnalyticsService } from '../../core/services/google-analytics.service';
import { translate } from 'src/app/core/utils/translateServiceHelper';

@Component({
  selector: 'app-report-patient-reslut',
  templateUrl: './report-patient-result.component.html',
  styleUrls: ['./report-patient-result.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class ReportPatientResultComponent extends BaseComponent implements OnInit, OnDestroy {
  @ViewChild('chart', { static: true }) private patientsResult: PatientsResultComponent;

  public selectedValue: ResultGroupType;
  public ResultGroupType = ResultGroupType;

  constructor(private queryService: QueryService,
    private searchService: SearchService,
    private titleService: TitleService,
    private filterService: FilterService,
    private toastr: NgxMatToastService,
    private googleAnalyticsService: GoogleAnalyticsService,
    private translate: TranslateService) {
    super();

    this.selectedValue = ResultGroupType.Assay;
  }

  ngOnInit(): void {

    this.subscription.add(this.queryService.filtersApplied.subscribe((filtersApplied: boolean) => {
      console.debug(`Filters applied: ${filtersApplied}`);
    }));

    this.subscription.add(this.queryService.searchRequested.subscribe(() => {
      this.onSearch();
    }));

    this.onSearch();

    this.titleService.updateTitleTranslateKey('ReportMenu.PatientsByResult');
  }

  onChange(changeValue: MatRadioChange): void {
    this.selectedValue = changeValue.value as ResultGroupType;
    console.debug('test');
    this.onSearch();
  }

  onSearch(): void {
    if (this.filterService.isReportEnabled(ReportKeys.PatientsByResult)) {
      this.googleAnalyticsService.logWithLabels('View Report', 'Report', 'View Patient By Results Report', 'filters', this.queryService.getCurrentQuery(true), 'groupType', this.googleAnalyticsService.getResultGroupType(this.selectedValue));
      this.subscription.add(this.searchService.getReportPatientsByResult(
        {
          query: this.queryService.getCurrentQuery(true),
          resultGroupType: this.selectedValue
        })
        .subscribe(
          (result: TestResult_PatientsByResultRow[]) => {
            if (!result || result.length === 0) {
              const title = translate(this.translate, 'ReportMenu.NoDataToShow');
              this.toastr.info(title);
              return;
            }

            this.patientsResult.setData(result);
          }));
    } else {
      const message = translate(this.translate, 'ReportMenu.RequirePatient');
      const title = translate(this.translate, 'ReportMenu.ReportLoadError');
      this.toastr.error(message, title);
    }
  }

  ngOnDestroyInternal(): void {
    // Required by base component
  }

  savePDF(): void {
    this.patientsResult.saveAsPdf();
  }

  saveImage(): void {
    this.patientsResult.saveAsImage();
  }

}
